<template>
  <div>
    <my-head></my-head>
    <div class="initiatingassignment minH">
      <div class="title flex-center">上海知识产权交易中心受让申请书</div>
      <div class="zhong_yao">
        重要提示：请认真查看本项目挂牌公告，按照公告要求提供指定的附件材料，如“意向受让方资格”的要求。
      </div>

      <el-tabs v-model="activeName">
        <el-tab-pane label="产权概况" name="1"></el-tab-pane>
        <el-tab-pane label="意向受让方信息" name="2"></el-tab-pane>
        <el-tab-pane label="受让意愿与承诺" name="3"></el-tab-pane>
      </el-tabs>

      <div v-show="activeName == 1">
        <div class="xiao_biao_ti">产权概况</div>

        <div class="jie_shao" style="margin-top: 24px">
          <div>
            <div class="xiang_xi">
              <div
                v-if="markReleasePO.floorPrice"
                class="jia_ge flex-left-center"
              >
                <span>¥</span>
                {{ markReleasePO.floorPrice }}
                <span style="margin-left: 6px">万元</span>
              </div>

              <div v-else class="jia_ge flex-left-center">面议</div>

              <div class="biao_qian flex-left">
                <div class="flex-center" v-show="markReleasePO.region">
                  {{ markReleasePO.region }}
                </div>

                <div
                  class="flex-center"
                  v-show="markReleasePO.propertyCategory"
                >
                  {{ markReleasePO.propertyCategory }}
                </div>

                <div
                  class="flex-center"
                  v-show="markReleasePO.propertyCategory == '专利'"
                  v-for="(item, index) in typelist"
                  :key="index"
                >
                  {{ item }}
                </div>

                <div class="flex-center" v-show="markReleasePO.projectDomain">
                  {{ markReleasePO.projectDomain }}
                </div>
              </div>

              <div class="xi_jie flex-left flex-wrap">
                <div>
                  项目所在国家/地区：
                  <span>{{ markReleasePO.regionName }}</span>
                </div>

                <div>
                  受托机构联系人：
                  <span v-if="form2.applicantType == '自然人'">
                    {{ markReleasePO.transferorName }}
                  </span>
                  <span v-else>
                    {{ markReleasePO.linkman }}
                  </span>
                </div>

                <div>
                  知识产权类别：
                  <span>{{
                    markReleasePO.propertyCategory == "其他"
                      ? markReleasePO.propertyCategoryExtra
                      : markReleasePO.propertyCategory
                  }}</span>
                </div>

                <div>
                  交易方式：
                  <span>{{ markReleasePO.dealWay }}</span>
                </div>
              </div>

              <div style="border-top: 1px solid #e5e6eb; width: 100%"></div>
              <div class="gong_si flex-left-center">
                <!-- <img
                src="http://www.sinoip.net/upload/img/store/slide/zzl0001.jpg"
              /> -->
                <div class="xin_xi flex-left flex-wrap">
                  <div class="flex-left-center">
                    申请人：
                    <span>{{ markReleasePO.transferorName }}</span>
                  </div>
                  <div class="flex-left-center">
                    电话：
                    <span>{{
                      markReleasePO.phone || markReleasePO.contactNumber
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <el-form :model="markReleasePO" ref="ruleForm1" label-width="140px">
          <el-form-item label="项目编号" prop="code">
            <el-input v-model="markReleasePO.code" disabled></el-input>
          </el-form-item>
          <el-form-item label="是否联合受让" prop="theJoint">
            <el-input
              type="textarea"
              v-model="markReleasePO.theJoint"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="知识产权名称" prop="name">
            <el-input v-model="markReleasePO.name" disabled></el-input>
          </el-form-item>
          <el-form-item label="知产类型" prop="propertyCategory">
            <el-input
              v-model="markReleasePO.propertyCategory"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="发布时间" prop="createTime">
            <el-input v-model="markReleasePO.createTime" disabled></el-input>
          </el-form-item>
          <el-form-item label="是否境外">
            <el-input v-model="markReleasePO.region" disabled></el-input>
          </el-form-item>
          <el-form-item label="专利类型">
            <el-input v-model="markReleasePO.patentType" disabled></el-input>
          </el-form-item>
          <el-form-item label="项目领域">
            <el-input
              v-model="markReleasePO.projectDomain"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="拟受让底价">
            <el-input
              style="width: 200px"
              v-model="markReleasePO.floorPrice"
              disabled
            ></el-input>
            万元
          </el-form-item>
        </el-form>

        <div class="flex-center bao_cun">
          <el-button type="primary" @click="submit('2')">下一页</el-button>
        </div>
      </div>

      <div v-show="activeName == 2">
        <div class="flex-left-center xiao_biao_ti">
          受让方基本信息
          <el-button type="primary" @click="toShouquan">去认证</el-button>
        </div>
        <el-form :model="form2" ref="ruleForm2" label-width="140px">
          <el-form-item label="意向受让方类型">
            <el-select
              v-model="srvalue"
              placeholder="请选择"
              @change="oneChange"
            >
              <el-option
                v-for="(item, index) in options1"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <div v-show="srvalue == 2 || srvalue == 3">
            <el-form-item label="意向受让方名称" prop="yxmingcheng">
              <el-select
                v-model="srvalue3"
                placeholder="请选择"
                @change="twoChange"
              >
                <el-option
                  v-for="(item, index) in options2"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="所属区域" prop="region">
              <el-input v-model="form2.region" disabled></el-input>
            </el-form-item>
            <el-form-item label="申请人类型" prop="applicantType">
              <el-input v-model="form2.applicantType" disabled></el-input>
            </el-form-item>
            <el-form-item label="企业类型" prop="enterpriseType">
              <el-input v-model="form2.enterpriseType" disabled></el-input>
            </el-form-item>

            <el-form-item label="注册地址" prop="domicile">
              <el-input v-model="form2.domicile" disabled></el-input>
            </el-form-item>
            <el-form-item label="法定代表人" prop="legalPerson">
              <el-input v-model="form2.legalPerson" disabled></el-input>
            </el-form-item>
            <el-form-item label="注册资本" prop="registeredCapital">
              <el-input v-model="form2.registeredCapital" disabled></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码" prop="code">
              <el-input v-model="form2.code" disabled></el-input>
            </el-form-item>
            <el-form-item label="经营范围" prop="businessScope">
              <el-input v-model="form2.businessScope" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contactPerson">
              <el-input v-model="form2.contactPerson" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input v-model="form2.contactPhone" disabled></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model="form2.email" disabled></el-input>
            </el-form-item>
            <el-form-item label="通讯地址" prop="address">
              <el-input v-model="form2.address" disabled></el-input>
            </el-form-item>
            <el-form-item label="内部决策情况">
              <div>
                以下决议已按公司法及其他有关法律法规要求完成，议事规则和决策程序符合规定。
              </div>
              <div>
                <el-radio-group v-model="form2.qingkuang" @change="jueceChange">
                  <el-radio label="股东会决议"></el-radio>
                  <el-radio label="董事会决议"></el-radio>
                  <el-radio label="总经理办公会决议"></el-radio>
                  <el-radio label="其他">
                    其他
                    <el-input
                      v-show="qtShow"
                      style="margin-left: 10px"
                      v-model="qtiInput"
                      placeholder="请输入内容"
                    ></el-input>
                  </el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
          </div>

          <div v-show="srvalue == 1">
            <el-form-item label="意向受让人名称" prop="name">
              <el-input v-model="form2.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系人">
              <el-input v-model="form2.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系电话">
              <el-input v-model="form2.phone" disabled></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱">
              <el-input v-model="form2.email" disabled></el-input>
            </el-form-item>
            <el-form-item label="通讯地址">
              <el-input v-model="form2.actualAddress" disabled></el-input>
            </el-form-item>
          </div>

          <el-form-item label="是否为关联方">
            <el-radio-group v-model="isAssoc">
              <el-radio label="0">否</el-radio>
              <el-radio label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

        <div class="flex-center bao_cun">
          <el-button type="primary" @click="submit('3')">下一页</el-button>
        </div>
      </div>

      <div v-show="activeName == 3">
        <div class="xiao_biao_ti">受让意愿与承诺</div>
        <el-input
          v-model="cn.riqi"
          type="textarea"
          autosize
          placeholder="请输入内容"
          class="nei_rong"
        ></el-input>
        <el-checkbox v-model="chengluo">
          我方保证遵守以上承诺，如违反上述承诺或有违规行为，给交易相关方、上海知识产权交易中心造成损失的，我方愿意承担法律责任及经济赔偿责任。</el-checkbox
        >
        <div class="flex-center bao_cun" style="margin-top: 24px">
          <el-button
            type="primary"
            @click="shenQing"
            :disabled="!chengluo || cn.riqi.length == 0"
          >
            提交申请
          </el-button>
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
import { getRequest, postRequest } from "../api/api";
export default {
  name: "initiatingassignment",
  components: {
    MyHead,
    MyFooter,
  },
  computed: {
    guoJi() {
      if (this.markReleasePO.region == "境外") {
        return "是";
      } else {
        return "否";
      }
    },
  },
  data() {
    return {
      cardsleft: 0,
      cardwidth: 100,
      pingFen: 4.7,
      activeName: "1", //tab选项 产权概况(1)意向受让方信息(2)受让意愿与承诺(3)
      // markReleasePO: {}, //表单1
      form2: {},
      isAssoc: "0",
      qtShow: false,
      qtiInput: "",
      chengluo: false, //是否同意承诺
      cn: {
        riqi: `1、我方自愿通过上海知识产权交易中心受让，受让行为是我方真实意愿表示；
          2、我方符合有关法律法规及本项目对意向受让方资格条件的规定，具有良好的财务状况、支付能力和商业信用，且资金来源合法；
          3、我方已完成全部尽职调查，已知晓相关法律法规的要求，知悉交易标的的各种情况，充分了解并自愿接受项目所公示全部内容、标的现状及瑕疵，愿承担可能存在的一切交易风险；
          4、我方受让标的相关行为已经有效的内部决策并得到相应的批准，所填信息及提交材料内容真实、完整、合法、有效，不存在虚假记载、误导性陈述或重大遗漏；
          5、我方在交易过程中，遵守法律法规规定和产权交易市场的相关规则，按照有关要求履行我方义务。若成功受让，我方将于《交易合同》签订之日起
          工作日内，以最终成交金额按交易底价部分的1%加上溢价部分的2%之和支付交易基本服务费至上海知识产权交易中心指定银行账户。（账户名称：上海知识产权交易中心有限公司，开户银行：上海农村商业银行股份有限公司漕河泾开发区支行，账号：50131000615653109）；`,
      },
      enterpriseOthers: [], //第三方企业授权认证列表
      enterprises: [], //企业授权认证列表
      markReleasePO: {}, //产品信息
      realnameAuthPO: {}, //个人授权认证

      //受让方类型
      options1: [
        {
          value: 1,
          label: "个人",
        },
        {
          value: 2,
          label: "企业",
        },
        {
          value: 3,
          label: "第三方企业",
        },
      ],
      srvalue: null, // 选择当前受让类型
      options2: null, //企业受让方选项
      srvalue2: null, // 选择当前受让企业
      srvalue3: null,
      imgList: null,
      img: null,
      typelist: [], //当产权类别为专利时的专利列表
    };
  },
  methods: {
    oneChange() {
      this.form2 = {};
      if (this.srvalue == 1) {
        this.form2 = this.realnameAuthPO;
      } else if (this.srvalue == 2) {
        this.options2 = this.enterprises;
        this.srvalue3 = null;
      } else if (this.srvalue == 3) {
        this.options2 = this.enterpriseOthers;
        this.srvalue3 = null;
      }
    },
    twoChange(n) {
      this.options2.forEach((item) => {
        if (item.id == n) {
          this.form2 = item;
          this.srvalue2 = item;
        }
      });
    },
    getData(id) {
      getRequest({
        url: "/api/v1/transfer/transferMessage",
        data: { id },
      }).then((res) => {
        if (res.errcode == 200) {
          this.enterpriseOthers = res.data.enterpriseOthers;
          this.enterprises = res.data.enterprises;
          this.realnameAuthPO = res.data.realnameAuthPO;
          this.markReleasePO = res.data.markReleasePO || {};

          this.markReleasePO.createTime = this.$moment(
            this.markReleasePO.createTime
          ).format("YYYY-MM-DD");

          this.imgList = JSON.parse(res.data.markReleasePO.imageUrl);
          this.img = this.imgList[0];

          this.typelist = res.data.markReleasePO.patentType.split(",");
        } else {
          alert(res.errmsg);
        }
      });
    },
    toShouquan() {
      let params = {
        tab: "授权中心",
      };
      this.$router.push({
        name: "my",
        params,
      });
    },
    shenQing() {
      if (this.confirmFrom() == false) return;
      let data = {
        markReleaseId: this.$route.query.id,
        type: this.srvalue,
        promiseText: this.cn.riqi,
        isAssoc: this.isAssoc,
      };
      if (this.srvalue == 2 || this.srvalue == 3) {
        data.enterpriseId = this.srvalue2.id;
        data.innerDecision = this.form2.qingkuang;
        data.innerDecisionExtra = this.qtiInput;
      }
      postRequest({ url: "/api/v1/markRelease/recv", data }).then((res) => {
        if (res.errcode == 200) {
          this.$message.success("提交成功");
          this.$router.go(-1);
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
    jueceChange() {
      this.qtiInput = "";
      if (this.form2.qingkuang == "其他") {
        this.qtShow = true;
      } else {
        this.qtiInput = this.form2.qingkuang;
        this.qtShow = false;
      }
    },
    // 表单保存
    submit(n) {
      if (n != 2) {
        if (this.confirmFrom() == false) return;
      }
      this.activeName = n;
    },
    // 确认意向受让方类型和意向受让人名称是否填写
    confirmFrom() {
      if (!this.srvalue || this.srvalue.length == 0) {
        this.$message.error("请选择意向受让方类型");
        return false;
      }
      if ((this.srvalue == 2 || this.srvalue == 3) && !this.srvalue3) {
        this.$message.error("意向受让方名称");
        return false;
      }
      return true;
    },
    cardsZ() {
      if (this.cardsleft < 0) {
        this.cardsleft += this.cardwidth;
      }
    },
    cardsY() {
      if (this.cardsleft > -this.cardwidth * (this.imgList.length - 1)) {
        this.cardsleft -= this.cardwidth;
      }
    },
    seeData(id) {
      getRequest({ url: `/api/v1/markReleaseRecv/getOne/${id}` }).then(
        (res) => {}
      );
    },
  },
  created() {
    let { id, type } = this.$route.query;
    // if (type == 1) {
    //   this.seeData(id)
    // } else {
    this.getData(id);
    // }
  },
};
</script>

<style lang="scss">
.initiatingassignment {
  width: 80%;
  margin: 24px auto 60px;
  .el-input.is-disabled .el-input__inner,
  .el-textarea.is-disabled .el-textarea__inner {
    color: #555555;
  }
  .nei_rong {
    .el-textarea__inner {
      padding: 24px;
      border: #4e5969 solid 1px;
      border-radius: 12px;
      font-size: 14px;
      line-height: 28px;
      margin: 12px 0 24px;
    }
    // padding: 24px;
    // border: #4e5969 solid 1px;
    // border-radius: 12px;
    // font-size: 14px;
    // line-height: 28px;
    // margin: 12px 0 24px;
    // .ri {
    //   width: 60px;
    // }
  }
  .xiao_biao_ti {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 12px;
    .el-button {
      padding: 3px 16px;
      margin-left: 16px;
    }
  }
  .bao_cun {
    .el-button {
      padding: 14px 120px;
    }
  }
  .jie_shao {
    margin-bottom: 80px;
    & > div {
      // width: 48%;
      .dian_ji {
        font-size: 12px;
        font-weight: 400;
        color: #86909c;
        line-height: 20px;
        span {
          color: #165dff;
        }
      }
      .buttons {
        width: 240px;
        font-size: 14px;
        font-weight: 500;
        img {
          width: 14px;
          margin-right: 8px;
        }
        .shou_rang {
          background: #165dff;
          color: #ffffff;
        }
        .shou_cang {
          color: #165dff;
        }
        .shou_cang_yi {
          color: #4e5969;
          border: none;
          background: #f2f3f5;
        }
        & > div {
          width: 114px;
          height: 36px;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #165dff;
          cursor: pointer;
        }
      }
      .gong_si {
        margin: 24px 0;
        .xin_xi {
          font-size: 14px;
          font-weight: 400;
          color: #86909c;
          line-height: 22px;
          & > div {
            margin-right: 16px;
            span {
              font-size: 16px;
              font-weight: 500;
              color: #1d2129;
              line-height: 24px;
            }
          }
        }
        img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          border: 1px solid #e5e6eb;
          margin-right: 12px;
        }
      }
      .xi_jie {
        padding-top: 12px;
        & > div {
          margin-right: 24px;
          font-size: 14px;
          font-weight: 400;
          color: #86909c;
          line-height: 22px;
          margin-bottom: 12px;
          span {
            color: #1d2129;
          }
        }
      }
      .ping_fen {
        font-size: 14px;
        font-weight: 400;
        color: #86909c;
        line-height: 22px;
        margin: 24px 0 12px;
      }
      .biao_qian {
        margin-bottom: 24px;
        & > div {
          height: 24px;
          background: #e8f3ff;
          border-radius: 2px 2px 2px 2px;
          font-size: 12px;
          font-weight: 400;
          color: #165dff;
          padding: 0 12px;
          margin-right: 8px;
        }
      }
      .xiang_xi {
        width: 100%;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #e5e6eb;
        padding: 24px;
        .jia_ge {
          font-size: 32px;
          font-weight: bold;
          color: #eb5757;
          line-height: 32px;
          margin-bottom: 16px;
          span {
            font-size: 24px;
            margin-right: 4px;
          }
        }
      }
      .list {
        height: 66px;
        overflow: hidden;
        width: 88%;
        .col {
          width: 76px;
          height: 66px;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #4e5969;
          margin: 0 12px;
          cursor: pointer;
        }
      }
      .tu_list {
        width: 100%;
        .fan_ye {
          width: 16px;
          height: 48px;
          background: #f2f3f5;
          border-radius: 2px 2px 2px 2px;
          cursor: pointer;
        }
      }
      .tu {
        width: 100%;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #e5e6eb;
        padding: 20px;
        margin-bottom: 24px;
        // img {
        //   width: 100%;
        // }
      }
    }
  }
  .zhong_yao {
    color: rgba(255, 1, 1, 100);
    font-size: 14px;
    margin-bottom: 24px;
  }
  .title {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 16px;
  }
}
</style>
